import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Providerss from './components/Providerss';

const providerss = (props,{ t }) => (
  <Container>
    <Providerss {...props} />
  </Container>
);

providerss.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(providerss);
